import * as mm from 'music-metadata-browser';
import Parse from 'parse';
import {fileSchema as Schema, ParseDbService} from "./parse.db.service";
import Axios from 'axios'

function ostMeta(ost) {
    return mm.parseBlob(ost)
}

function getLength(meta) {
    return sec2time(meta.format.duration)
}

function getArtist(meta) {
    return meta.common.artist
}

function getAlbum(meta) {
    return meta.common.album
}

function getTracks(meta) {
    return meta.common.track
}

function sec2time(timeInSeconds) {
    let pad = function (num, size) {
            return ('000' + num).slice(size * -1);
        },
        time = parseFloat(timeInSeconds).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60);

    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
}


function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.AudioFileClassName);
    if (pagination) {
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }
    query.withCount(true);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.name, search);
    }
    return query.find().then((items) => {
        console.log(items);

        return {
            results: items.results.map(fileToAdd => {
                return {
                    parseItem: fileToAdd,
                    id: fileToAdd.id,
                    file: fileToAdd.get('file'),
                    name: fileToAdd.get('name'),
                    size: fileToAdd.get('size'),
                    length: fileToAdd.get('length')
                }
            }),
            count: items.count
        };
    });
}

function add(item) {
    let file = new Parse.File(item.name.toLowerCase(), item.ostFile);
    return file.save(null).then(parsedFile => {
        let AudioFile = Parse.Object.extend(ParseDbService.AudioFileClassName, null, null);
        let audioFile = new AudioFile();
        audioFile.set(Schema.file, parsedFile);
        audioFile.set(Schema.name, item.name.toLowerCase());
        audioFile.set(Schema.size, item.size);
        audioFile.set(Schema.length, item.length);
        return audioFile.save({})
    });
}

function edit(item) {
    let AudioFile = Parse.Object.extend(ParseDbService.AudioFileClassName, null, null);
    let audioFile = new AudioFile();
    audioFile.id = item.id;
    audioFile.set(Schema.name, item.name.toLowerCase());
    return audioFile.save();
}


function download(url, name) {
    Axios.get(url, {
        responseType: 'arraybuffer'
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'audio/ogg'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);//or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}

export const FileService = {
    ostMeta,
    getLength,
    getArtist,
    getAlbum,
    getTracks,
    download,
    getAll,
    add,
    edit
};